import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../lib/analytics';
import AppBrand from '../components/AppBrand';

function OnboardingPage({ theme = 'dark' }) {
  const navigate = useNavigate();
  const darkMode = theme === 'dark';

  useEffect(() => {
    trackEvent('onboarding_opened');
  }, []);

  const handleFeedbackClick = () => {
    trackEvent('onboarding_feedback_clicked');
    navigate('/feedback');
  };

  const handleAnalyzerClick = () => {
    trackEvent('onboarding_open_analyzer_clicked');
    navigate('/');
  };

  return (
    <div className={`legal-page-shell ${darkMode ? 'dark' : 'light'}`}>
      <div className="legal-page-container">
        <AppBrand theme={theme} />
        <div className="legal-page-topbar">
          <button
            type="button"
            className="back-link-btn"
            onClick={() => navigate('/')}
          >
            ← Back to App
          </button>
        </div>

        <div className="legal-page-card onboarding-page-card">
          <div className="legal-page-badge">Getting Started</div>
          <h1 className="legal-page-title">How StockVested Works</h1>
          <p className="legal-page-updated">
            Use the app to review chart structure, save research, and track your process.
          </p>

          <div className="onboarding-steps">
            <div className="onboarding-step-card">
              <div className="onboarding-step-number">1</div>
              <h2>Run chart structure review</h2>
              <p>
                Enter a ticker in the analyzer. The app highlights technical structure
                and related company context to help speed up your review process.
              </p>
            </div>

            <div className="onboarding-step-card">
              <div className="onboarding-step-number">2</div>
              <h2>Save a setup to journal</h2>
              <p>
                If a setup is worth tracking, add it to your journal. This gives you a
                dedicated place to keep notes and preserve the structure snapshot.
              </p>
            </div>

            <div className="onboarding-step-card">
              <div className="onboarding-step-number">3</div>
              <h2>Update outcome later</h2>
              <p>
                When the trade develops, go back into the journal and update the outcome
                status and whether you followed your plan.
              </p>
            </div>

            <div className="onboarding-step-card">
              <div className="onboarding-step-number">4</div>
              <h2>Review performance metrics</h2>
              <p>
                Use the Performance page to review wins, losses, process discipline,
                and recent journal results over time.
              </p>
            </div>
          </div>

          <div className="onboarding-contact-card">
            <h2>Questions or feedback?</h2>
            <p>
              If something is unclear or you want to suggest an improvement, use the
              feedback page to send notes directly from the app.
            </p>

            <div className="onboarding-contact-actions">
              <button
                type="button"
                className="onboarding-contact-link"
                onClick={handleFeedbackClick}
              >
                Give Feedback
              </button>

              <button
                type="button"
                className="desktop-secondary-btn"
                onClick={handleAnalyzerClick}
              >
                Open Analyzer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingPage;